import React from 'react';
import { Link } from 'react-router-dom';

export const packageLinkStyles =
  'text-blue-500 hover:text-blue-700 underline hover:underline-offset-2 focus:outline-none focus:ring-2 focus:ring-blue-300';

export type PackageLinkProps = {
  idPackage?: number;
  name?: string;
  /** Shown when there is no name, e.g. `No Package Selected`. */
  fallback?: string;
};

/**
 * A package name linked to its detail page, for the read-only rows that show
 * which package a user or team is on.
 *
 * Falls back to plain text unless both the id and the name are present, so a
 * name we could not resolve never becomes a link to nowhere.
 */
export const PackageLink = ({
  idPackage,
  name,
  fallback = '',
}: PackageLinkProps) => {
  const label = name || fallback;

  return idPackage && name ? (
    <Link to={`/packages/${idPackage}`} className={packageLinkStyles}>
      {label}
    </Link>
  ) : (
    <span>{label}</span>
  );
};

export default PackageLink;
